import { StrictDict } from '../../../utils';
import circuitSchematic from './circuitschematic';
import customGrader from './customgrader';
import formulaResponse from './formularesponse';
import imageResponse from './imageresponse';
import jsInputResponse from './jsinput_response';
import problemWithHint from './problem_with_hint';

export default StrictDict({
  circuitSchematic,
  customGrader,
  formulaResponse,
  imageResponse,
  jsInputResponse,
  problemWithHint,
});
